import React from "react";
import styled from "styled-components";
import theme from "../../theme";

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  select,
  textarea {
    width: 100%;
    margin-top: 10px;
    border: 1px solid ${theme.color.border};
    border-radius: 10px;
    padding: 12px 14px;
    font: inherit;
    font-size: ${theme.font.body};
    background: ${theme.color.surface};
    color: ${theme.color.text};

    &:focus {
      outline: none;
      border-color: ${theme.color.brandDark};
    }
  }

  textarea {
    min-height: 180px;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: ${theme.font.small};
    line-height: 1.5;
    resize: vertical;
  }

  .hint {
    font-size: ${theme.font.small};
    color: ${theme.color.textMuted};
    line-height: 1.5;
  }

  code {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    background: ${theme.color.surfaceAlt};
    padding: 1px 5px;
    border-radius: 4px;
  }
`;

const EXAMPLE = `{
  "serviceId": "{productId}",
  "msisdn": "{msisdn}",
  "clickId": "{clickID}"
}`;

// Turns the textarea value into the object the API expects.
// Returns { body } on success or { error } with a message to show.
export const parsePostbackBody = (text) => {
  if (!text || !text.trim()) {
    return { error: "A postback body is required for POST publishers." };
  }
  try {
    const body = JSON.parse(text);
    if (!body || typeof body !== "object" || Array.isArray(body)) {
      return { error: "The postback body must be a JSON object, e.g. { \"key\": \"value\" }." };
    }
    return { body };
  } catch (e) {
    return { error: `The postback body is not valid JSON: ${e.message}` };
  }
};

const PostbackFields = ({ method, body, onChange, Wrapper }) => (
  <>
    <Wrapper>
      <label htmlFor="postbackMethod">Postback method</label>
      <Field>
        <select
          id="postbackMethod"
          name="postbackMethod"
          value={method}
          onChange={onChange}
        >
          <option value="GET">GET: click ID in the postback URL</option>
          <option value="POST">POST: JSON body sent to the postback URL</option>
        </select>
      </Field>
    </Wrapper>

    {method === "POST" && (
      <Wrapper>
        <label htmlFor="postbackBody">Postback body (JSON)</label>
        <Field>
          <textarea
            id="postbackBody"
            name="postbackBody"
            placeholder={EXAMPLE}
            value={body}
            onChange={onChange}
            spellCheck={false}
          />
          <span className="hint">
            Filled in for each conversion: <code>{"{clickID}"}</code> the
            publisher's click ID, <code>{"{sourceID}"}</code>,{" "}
            <code>{"{msisdn}"}</code> (empty when unknown) and{" "}
            <code>{"{productId}"}</code> the campaign's Product ID (service ID).
          </span>
        </Field>
      </Wrapper>
    )}
  </>
);

export default PostbackFields;
